var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      class: `pl-${_vm.paddingLeft} pr-${_vm.paddingRight} pb-${
        _vm.isMobilePort ? 3 : ""
      }`,
      attrs: { cols: "12", md: "3" },
    },
    [
      _vm.isMobilePort
        ? [
            _vm.menuGroups.length > 1
              ? _c(
                  "v-menu",
                  {
                    attrs: { "offset-y": "", "close-on-content-click": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      class: _vm.btnClassName,
                                      attrs: {
                                        block: "",
                                        depressed: "",
                                        "x-large": "",
                                        color: "primary",
                                        height: "52",
                                        "aria-haspopup": "true",
                                        "aria-expanded":
                                          _vm.menuIsActive.toString(),
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.title) +
                                      "\n                    "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v("mdi-menu-down"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3469864420
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "v-card",
                      { staticStyle: { "min-width": "400px" } },
                      [
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              [
                                _c(
                                  "v-list",
                                  { attrs: { dense: "", role: "menu" } },
                                  _vm._l(_vm.menuGroups, function (group, i) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: i,
                                        attrs: {
                                          role: "menuitem",
                                          href: _vm.getCategoryUrlFromSlug(
                                            group.slug
                                          ),
                                        },
                                      },
                                      [
                                        _c("v-list-item-content", [
                                          _vm._v(_vm._s(group.title)),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "v-btn",
                  {
                    attrs: {
                      block: "",
                      depressed: "",
                      "x-large": "",
                      color: "primary",
                      height: "52",
                      href: _vm.getCategoryUrlFromSlug(
                        _vm.menuGroups[0]["slug"]
                      ),
                    },
                  },
                  [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
                ),
          ]
        : [
            _c(
              "v-menu",
              {
                attrs: { "offset-y": "", "close-on-content-click": "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                class: _vm.btnClassName,
                                attrs: {
                                  block: "",
                                  depressed: "",
                                  "x-large": "",
                                  color: "primary",
                                  height: "52",
                                  "aria-haspopup": "true",
                                  "aria-expanded": _vm.menuIsActive.toString(),
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.title) +
                                "\n                    "
                            ),
                            _c("v-icon", { attrs: { right: "" } }, [
                              _vm._v("mdi-menu-down"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c(
                  "v-card",
                  { staticStyle: { "min-width": "400px" } },
                  [
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      _vm._l(_vm.menuGroups, function (group, i) {
                        return _c(
                          "v-col",
                          { key: i },
                          [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "list-subtitle font-weight-bold pa-4",
                              },
                              [_vm._v(_vm._s(group.title))]
                            ),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-list",
                              {
                                style: _vm.calculateColumnCountStyle(
                                  group.items?.length || 0
                                ),
                                attrs: { dense: "", role: "menu" },
                              },
                              _vm._l(group.items, function (item) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: item.key,
                                    attrs: {
                                      role: "menuitem",
                                      href: _vm.getCategoryUrlFromSlug(
                                        item.slug
                                      ),
                                    },
                                  },
                                  [
                                    _c("v-list-item-content", [
                                      _vm._v(_vm._s(item.name)),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }